import { API } from "../Config/API";

const getURL = (url: any) => {
  if (!url || typeof url !== "string") return url;

  const passthroughHosts = API.CDN_PASSTHROUGH_HOST.split(",")
    .map((h) => h.trim())
    .filter(Boolean);
  if (passthroughHosts.some((host) => url.includes(host))) return url;

  const parts = url.split("/");
  if (parts.length < 5 || !parts[3] || !parts[4]) return url;

  // Preserve the FULL path after the host (not just the first two segments).
  // New epaper URLs are {date}/{edition}/{filename} (3 segments) — keeping only
  // parts[3]/parts[4] dropped the filename, which both 404'd the image and
  // stripped the "-epaper-" token the S3 fallback keys on. slice(3) is identical
  // for the old 2-segment URLs, so this is backward-compatible.
  return `${API.CDN_URL}${parts.slice(3).join("/")}`;
};

export { getURL };
